import BaseAPI from "./BaseAPI";
import { issueRoute } from "../routes";
import { newIdempotencyKey } from "@/composables/globalMethods";

export default class IssueAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, issueRoute, "issue");
    }

    async Create(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("create", result.id);
        return result;
    }

    async ListWithStatus(status) {
        return this._request("get", this._url(`?status=${status}`));
    }

    async AddComment(id, data, idempotencyKey = newIdempotencyKey()) {
        return this._request("post", this._url(`/${id}/comments`), data, {
            headers: { "Idempotency-Key": idempotencyKey }
        });
    }

    async UpdateComment(id, commentId, text) {
        return this._request("put", this._url(`/${id}/comments/${commentId}`), { text });
    }

    async DeleteComment(id, commentId) {
        return this._request("delete", this._url(`/${id}/comments/${commentId}`));
    }

    async Resolve(id, data, idempotencyKey = newIdempotencyKey()) {
        return this._request("post", this._url(`/${id}/resolve`), data, {
            headers: { "Idempotency-Key": idempotencyKey }
        });
    }

    async Reopen(id) {
        return this._request("post", this._url(`/${id}/reopen`));
    }

    async Acknowledge(id, excursion, idempotencyKey) {
        return this._request(
            "post",
            this._url(`/${id}/acknowledge`),
            { excursion },
            {
                headers: { "Idempotency-Key": idempotencyKey }
            }
        );
    }
}
